import React, { useState ,useEffect} from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronRight } from "lucide-react";
import axios from "axios";


const SiteMap = () => {
    useEffect(() => {
          const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
          axios.post(`${backendUrl}/api/analytics/visit`, { page: "Site map" })
            .then(res => console.log(" visit recorded:", res.data))
            .catch(err => console.error("Analytics error:", err));
        }, []);
  const [openSections, setOpenSections] = useState({});

  const links = [
    {
      path: "/",
      label: "Home",
      children: [
        { path: "/collection", label: "Collection" },
        { path: "/about", label: "About" },
        { path: "/contact", label: "Contact" },
      ],
    },
    { path: "/cart", label: "Cart" },
    {
      path: "/auth",
      label: "Authentication",
      children: [
        { path: "/login", label: "Login" },
        { path: "/signup", label: "Sign Up" },
        { path: "/reset-password", label: "Reset Password" },
      ],
    },
    {
      path: "/orders",
      label: "Orders",
      children: [{ path: "/place-order", label: "Place Order" }],
    },
    { path: "/profile", label: "Profile" },
    {
      path: "/info",
      label: "Information",
      children: [
        { path: "/privacy-policy", label: "Privacy Policy" },
        { path: "/termandc", label: "Terms & Conditions" },
        { path: "/career", label: "Career" },
        { path: "/return-exchange", label: "Exchange & Return" },
      ],
    },
     {
      path: "/category",
      label: "Catogory",
      children: [
        { path: "/men", label: "Mens" },
        { path: "/women", label: "Womens" },
        { path: "/kids", label: "Kids" },
        
      ],
    },
  ];

  const toggleSection = (index) => {
    setOpenSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const renderLinks = (items, parentIndex = "") => (
    <ul className="ml-4 border-l pl-4">
      {items.map((item, index) => {
        const uniqueIndex = `${parentIndex}${index}`;
        return (
          <li key={uniqueIndex} className="mb-2">
            <div
              className="flex items-center cursor-pointer text-[#FF4902] hover:text-orange-800"
              onClick={() => item.children && toggleSection(uniqueIndex)}
            >
              {item.children && (
                <span className="mr-2">
                  {openSections[uniqueIndex] ? (
                    <ChevronDown size={14} />
                  ) : (
                    <ChevronRight size={14} />
                  )}
                </span>
              )}
              <Link to={item.path}>{item.label}</Link>
            </div>
            {item.children && openSections[uniqueIndex] && renderLinks(item.children, uniqueIndex)}
          </li>
        );
      })}
    </ul>
  );

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-10">
      <h1 className="text-3xl font-bold text--[#FF4902] mb-4">Site Map</h1>
      <div className="breadcrumbs text-sm">
        <ul>{renderLinks(links)}</ul>
      </div>
    </div>
  );
};

export default SiteMap;
